module.exports = __webpack_public_path__ + "static/media/knowledge-base.b2882630.svg";